import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KitchenService } from '../../restaurants/services/Kitchen.service';

export interface DialogData {
  kitchenId: any
  type: any
}
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html'
})


export class ListComponent implements OnInit {
  dataLoading = false;
  items: any = []
  members: any = []
  lang = localStorage.getItem('language') || 'en';
  constructor(private dialogRef: MatDialogRef<ListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private kitchenService: KitchenService) { }

  ngOnInit(): void {
    if (this.data.type == 1) {
      this.GetMenuitemKitchens()
    } else {
      this.getStaffsKitchens()
    }
  }

  GetMenuitemKitchens() {
    this.dataLoading = true
    this.kitchenService.GetMenuitemKitchens(this.data.kitchenId).subscribe((data) => {
      this.dataLoading = false
      this.items = data;
    })
  }
  getStaffsKitchens() {
    this.dataLoading = true
    this.kitchenService.getStaffsKitchens(this.data.kitchenId).subscribe((data) => {
      this.dataLoading = false
      this.members = data;
    })
  }
}
